module.exports = __webpack_public_path__ + "assets/img/DS-room3 (1).326ff86f.jpg";